import I18n from 'I18n';
import CreateActivityButton from './CreateActivityButton';
import { useCreateActivityPermissions } from 'crm-activity-creator-data/permission/CreateActivityPermissionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
function CreateLogLinkedInButton({
  interactionName,
  objectId,
  objectTypeId,
  taskId,
  buttonSize,
  isOverflow = false,
  onClickActionComplete
}) {
  const {
    currentUserCanCommunicate
  } = useCreateActivityPermissions();
  const tooltip = !currentUserCanCommunicate ? I18n.text('createActivityButtons.tooltip.disabled') : undefined;
  return /*#__PURE__*/_jsx(CreateActivityButton, {
    interactionName: interactionName,
    objectId: objectId,
    objectTypeId: objectTypeId,
    taskId: taskId,
    buttonSize: buttonSize,
    isOverflow: isOverflow,
    tooltipMessage: tooltip,
    disabled: !currentUserCanCommunicate,
    onClick: onClickActionComplete,
    dataTestId: "create-engagement-logged-linked-in-button",
    seleniumSelector: "create-engagement-logged-linked-in-message-button"
  });
}
export default CreateLogLinkedInButton;